module.exports = __webpack_public_path__ + "static/img/patho-edema-high-BwzlZRSZ.2222cf31.png";